<p-tabView>
    <p-tabPanel header="Profile">
        <p-table [value]="profile" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Created By</th>
                    <th>Last Updated</th>
                    <th>Associated Users</th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-profile>
                <tr>
                    <td>{{profile?.name}}</td>
                    <td *ngIf="profile.description == null"></td>
                    <td pTooltip="{{ profile?.description }}" tooltipPosition="top" *ngIf="profile.description != null">
                        {{ (profile?.description.length > 80) ? (profile?.description | slice:0:80)+'...' : (profile?.description) }} 
                    </td>
                    <td>{{profile?.createdBy}}</td>
                    <td>{{profile?.lastUpdatedDate | localDate}}</td>
                    <td class="p-col-2 click-enable" (click)="getNoOfAssociatedUsers(profile?.id)"> {{profile?.noOfAssociatedUsers}} </td> 
                    <td class="action">
                        <span class="btnBars p-mr-0"
                        (click)="showEditProfile(profile)" pTooltip="Edit" tooltipPosition="top">
                            <i class="pi pi-pencil"></i>
                        </span>
                        <span class="btnBars p-mr-0" (click)="deleteProfileConfirmation(profile)" 
                        pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
                        <span class="btnBars p-mr-0" (click)="copyProfile(profile)" pTooltip="Copy"
                        tooltipPosition="top"><i class="pi pi-clone"></i></span>
                        <span class="btnBars p-mr-0" (click)="setProfilePermissions(profile)" pTooltip="Permission"
                        tooltipPosition="top"><i class="pi pi-lock"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-tabPanel>
    <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
        <ng-template pTemplate="header">
          <p-menu #configmenuUser id="config_menu_user" [model]="configMenuProfileItems" [popup]="true"
            appendTo="body"></p-menu>
          <span class="btnBars p-mr-0" (click)="configmenuUser.toggle($event)">
            <i class="pi pi-bars"></i>
          </span>
        </ng-template>
    </p-tabPanel>
</p-tabView>

<p-dialog header="{{addEditProfileHeader}}" [modal]="true" [(visible)]="displayAddEditProfileModal"
[style]="{width: '60vw'}" [baseZIndex]="10000" (onHide)="cancelAddEditProfileModal()">
    <form [formGroup]="profileAddEditForm" (ngSubmit)="saveProfile()" #AddEditUserForm="ngForm" >
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                  <label>Profile Name <span style="color: red;">*</span> </label>
                  <input type="text" pInputText formControlName="name"> 
                  <small *ngIf="name.invalid && (name.touched || name.dirty)" class="p-invalid">
                    <span *ngIf="name.errors?.['required']" class="p-invalid">
                      Profile name is required
                    </span>
                  </small>
                </div>
            </div>
            <div class="p-grid" *ngIf="isShowClonedPermissionDiv">
                <div class="p-col-12">
                <label>Profile Clone From</label>
                  <p-dropdown
                    [options]="cloneProfileList"
                    optionLabel="name"
                    appendTo="body"
                    placeholder="Select a profile"
                    formControlName="cloneProfile">
                  </p-dropdown>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12">
                  <label>Profile Description</label>
                  <textarea pInputTextarea name="description" rows="5" formControlName="description"></textarea>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="cancelAddEditProfileModal()" label="Cancel" class="p-button-secondary"></button>
        <button pButton (click)="saveProfile()" [disabled]="profileAddEditForm.invalid"
        label="Save"></button>
    </ng-template>
</p-dialog>

<!-- permission -->
<p-dialog header="Edit Permission" [modal]="true" [(visible)]="displayPermission" [style]="{width: '60vw'}"
    [baseZIndex]="10000" (onHide)="cancelPermissionModal()" class="no-padding-top">
    <p-tabView [(activeIndex)]="permissionTabIndex" class="no-padding">
        <p-tabPanel header="{{'Configuration.User.Assign_Permission' | transloco}} (Profile -
        {{selectedProfile?.name}})">
            <form>
                <p-treeTable [value]="modulePermissions" [scrollable]="true" [scrollHeight]="scrHeight">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 300px;">Module</th>
                            <th>{{'Configuration.User.View' | transloco}}</th>
                            <th>Create</th>
                            <th>Edit</th>
                            <th>Delete</th>
                            <th>Export</th>
                        </tr>
                    </ng-template>
                
                    <ng-template pTemplate="body" let-rowNode let-rowData="rowData" >
                        <tr [ttRow]="rowNode">
                            <td style="width: 300px;">
                                <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                                {{rowData.name}}
                            </td>
                            <td>
                                <p-checkbox [(ngModel)]="rowData.isView" (onChange)="checkAllData(rowData,'view')"
                                binary="true" [ngModelOptions]="{standalone: true}"></p-checkbox>
                            </td>
                            <td>
                                <p-checkbox [(ngModel)]="rowData.isCreate" (onChange)="checkAllData(rowData,'create')"
                                binary="true" [ngModelOptions]="{standalone: true}"></p-checkbox>
                            </td>
                            <td>
                                <p-checkbox [(ngModel)]="rowData.isEdit" (onChange)="checkAllData(rowData,'edit')"
                                binary="true" [ngModelOptions]="{standalone: true}"></p-checkbox>
                            </td>
                            <td>
                                <p-checkbox [(ngModel)]="rowData.isDelete" (onChange)="checkAllData(rowData,'delete')"
                                binary="true" [ngModelOptions]="{standalone: true}"></p-checkbox>
                            </td>
                            <td>
                                <p-checkbox [(ngModel)]="rowData.isExport" (onChange)="checkAllData(rowData,'export')"
                                binary="true" [ngModelOptions]="{standalone: true}"></p-checkbox>
                            </td>
                        </tr>
                    </ng-template>
                </p-treeTable>
            </form>
        </p-tabPanel> 
        <p-tabPanel header="{{'Configuration.User.Reports' | transloco}} - (Profile -
        {{selectedProfile?.name}})">
            <form>
                <p-treeTable [value]="profileReportPermissionData" [scrollable]="true" [scrollHeight]="scrHeight">
                    <ng-template pTemplate="header">
                        <tr>
                        <th>{{'Configuration.User.Report_Module' | transloco}}</th>
                        <th>{{'Configuration.User.View' | transloco}}</th>
                        <th>{{'Configuration.User.Export' | transloco}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
            
                        <tr [ttRow]="rowNode">
                        <td>
                            <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                            {{rowData.name}}
                        </td>
                        <td>
                            <p-checkbox [(ngModel)]="rowData.isView" (onChange)="checkUncheckReport(rowData,'view')"
                            binary="true" [ngModelOptions]="{standalone: true}"></p-checkbox>
                        </td>
                        <td>
                            <p-checkbox [(ngModel)]="rowData.isExport" (onChange)="checkUncheckReport(rowData,'export')"
                            binary="true" [ngModelOptions]="{standalone: true}"></p-checkbox>
                        </td>
                        </tr>
                    </ng-template>
                </p-treeTable>
            </form>
        </p-tabPanel>
    </p-tabView>
    <ng-template pTemplate="footer">
        <ng-container *ngIf="permissionTabIndex == 0">
            <button pButton label="Cancel" class="p-button-secondary" (click)="cancelPermissionModal()"></button>

            <button type="submit" (click)="assignModulePermission();" pButton
                label="{{'Configuration.User.Save' | transloco}}"></button>
        </ng-container>
        <ng-container *ngIf="permissionTabIndex==1">
            <button pButton label="{{'Configuration.User.Cancel' | transloco}}" class="p-button-secondary"
                (click)="cancelPermissionModal()"></button>
            <button type="submit" (click)="assignReportPermission();" pButton
                label="{{'Configuration.User.Save' | transloco}}"></button>
        </ng-container>
    </ng-template>
</p-dialog>

<app-shared-associated-users 
    [displayAssociatedUsersModal]="displayAssociatedUsersModal"
    [associatedUsersFrom]="subModuleName"
    [associatedUsersSubModuleId]="profileIdForSelectedAssociatedUser"
    [associatedUsers]="associatedUsers"
    (closeAssociatedUserModalOutputEvent)="closeAssociatedUserModalOutputEvent()"
    (completedAddNewUser)="completedAddNewUser()">
    
</app-shared-associated-users>

<!-- Transfer Profile Modal -->
<p-dialog header="Transfer Profile" [modal]="true" [(visible)]="displayTransferProfileModal" [style]="{width: '50vw'}"
    [baseZIndex]="10000" (onHide)="closeTransferProfileModal()">
    <form [formGroup]="profileTransferForm">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <p>Profile to be deleted: <b>{{profileDataForTransfer?.name}}</b></p>
                </div>
                <div class="p-col-12">
                    <label for="type">Move users to Profile<span style="color: red;">*</span></label>
                    <p-dropdown [options]="filteredProfiles" optionLabel="name" placeholder="Select a profile"
                        appendTo="body" formControlName="newProfile"></p-dropdown>
                    <small *ngIf="newProfile.invalid && (newProfile.touched || newProfile.dirty)" class="p-invalid">
                        <span *ngIf="newProfile.errors?.['required']" class="p-invalid">
                            New profile is required
                        </span>
                    </small>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="closeTransferProfileModal()" label="Cancel"
            class="p-button-secondary"></button>
        <button pButton (click)="transferAndDeleteProfile()" label="Transfer and Delete" [disabled]="profileTransferForm.invalid"></button>
    </ng-template>
</p-dialog>